// Rich text editor configuration constants
export const DEFAULT_RICH_TEXT_PLUGINS = 'link lists';
export const DEFAULT_RICH_TEXT_TOOLBAR = [
  'styleselect | bold italic link unlink | forecolor backcolor | alignleft aligncenter alignright | bullist numlist | removeformat',
];

